









































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import OptionSideBar from '@/layouts/gripper/components/QuickLabeling/OptionSideBar.vue';
import ImagesGrid from '@/layouts/gripper/components/QuickLabeling/ImagesGrid.vue';
import TaskElaboration from './components/TaskElaboration.vue';
import {Resource, Option, ConditionState} from '@/types/gripper';
import {
  DeleteJobResourceInput,
  JobDataset,
  JobDataset_job_dataset_resources_data as Resources_data,
  JobDataset_job_dataset_resources_data_predictions, JobDataset_job_dataset_resources_data_values, JobInfo,
  JobInfo_job_task_parameter,
  UpdateJobResourceCheckInput,
  UpdateJobResourceNegativeInput,
} from '@/types/intrador';
import MessageCategoryIsDone from '@/layouts/gripper/components/MessageCategoryIsDone.vue';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import {SmartQuery} from 'vue-apollo/types/vue-apollo';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';

@Component({
  components: {
    DirectionSwitch,
    MessageCategoryIsDone,
    TaskElaboration,
    ImagesGrid,
    OptionSideBar,
    IntradorLoader,
    PaginateButtonsShrinkingBin,
  },
  metaInfo: {
    title: 'Quick Labelling',
  },
})

export default class QuickLabelling extends Vue {

  @Prop(Object) public jobInfo!: JobInfo;
  @Prop(Array) public options!: Option[];
  @Prop(Object) public selectedParameterOption!: Option;
  @Prop(Object) private parameter!: JobInfo_job_task_parameter;

  private JobDataset!: JobDataset;

  private selectBase: boolean = false;
  private isDragging: boolean = false;
  private imagesData: Resource[] = [];

  private page: number = 1;
  private limit: number = 48;
  private totalPages: number = 0;
  private base: string = 'PREDICTION';

  public async persistAllToDB() {
    await Promise.all(this.imagesData.map(async (resource: Resource) => {
      await this.persistToDatabase(resource);
    }));
  }

  get queryVariables() {
    return {
      jobID: this.jobInfo!.job!.id,
      page: this.page,
      limit: this.limit,
      parameter_id: this.parameter.id,
      parameter_value: {
        parameter_id: this.parameter.id,
        option_id: this.selectedParameterOption!.id,
        base: this.base,
      },
    };
  }

  // if we have only two options, we have a slightly different label made
  get isBooleanToggleMode() {
    if (this.parameter.type === 'bool' ||
      this.parameter.type === 'image' ||
      this.parameter.type === 'image_set' ||
      this.parameter.type === 'parameter_set') {
      return true;
    }
    return false;
  }

  @Watch('selectBase')
  protected onModelChange(selectBase: any | null) {
    setTimeout(() => {
        this.base = selectBase ? 'VALUE' : 'PREDICTION';
        this.refetch();
      },
      1000);
  }

  private get queryResult(): SmartQuery<any> {
    return (this.$refs.apolloQuery as any).getApolloQuery();
  }

  private get canChangePage(): boolean {
    return this.imagesData.every((resource) => !resource.isMutating);
  }

  private created() {
    window.addEventListener('mousedown', this.dragEnable);
    window.addEventListener('mouseup', this.dragDisable);
  }

  private dragEnable(event: MouseEvent) {
    this.isDragging = true;
  }

  private dragDisable(event: MouseEvent) {
    this.isDragging = false;
  }

  private refetch() {
    if (this.queryResult) {
      this.queryResult.refresh();
    }
  }

  private resolveData(data: JobDataset) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }

    this.JobDataset = data;

    this.totalPages = Math.ceil(data.job.dataset.resources.paginatorInfo.total / this.limit);
    this.resolveImagesData(data);

    return data;
  }

  private resolveImagesData(data: JobDataset) {
    if (!data || !data.job || !data.job.dataset || !data.job.dataset.resources) {
      return false;
    }
    this.imagesData = [];

    data.job.dataset.resources.data.forEach((item: Resources_data) => {
      if (this.imagesData.findIndex((i: Resource) => i.id === item.id) < 0) {

        let hasSelectedOption = false;

        if (item.predictions && item.predictions.length > 0) {
          hasSelectedOption = hasSelectedOption || item.predictions.some(this.isPredictionOrValueForCurrentClass);
        }
        if (item.values && item.values.length > 0) {
          hasSelectedOption = hasSelectedOption || item.values.some(this.isPredictionOrValueForCurrentClass);
        }

        const resource: Resource = {
          id: item.id,
          url: item.url,
          isSelected: hasSelectedOption,
          isMutating: false,
          isDeleted: false,
          type: item.type,
        };
        this.imagesData.push(resource);
      }
    });

  }

  private isPredictionOrValueForCurrentClass(value: JobDataset_job_dataset_resources_data_predictions
    | JobDataset_job_dataset_resources_data_values): boolean {
    return value.option !== null && value.option?.id === this.selectedParameterOption.id;
  }

  private changeOption(option: Option) {
    this.$emit('onClickChangeLabel', option);
    this.refetch();
  }

  private async pageChange(newPage: number) {
    if (this.JobDataset &&
      this.JobDataset.job &&
      this.JobDataset.job.dataset &&
      this.JobDataset.job.dataset.resources) {

      await this.persistAllToDB();

      this.page = newPage;
      this.imagesData = [];
      this.refetch();
    }
  }

  private markResource(resource: Resource) {
    // mark the resouce as remove (set option to null) or set resource to belong to the current selected label
    resource.isSelected = !resource.isSelected;
  }

  private async persistToDatabase(resource: Resource) {
    resource.isMutating = true;

    let variables = null;
    let query = null;
    if (this.isBooleanToggleMode) {
      variables = this.resolveUpdateJobResourceCheckInput(resource);
      query = require('@/graphql/mutations/UpdateJobResourceCheck.graphql');
    } else {
      if (resource.isSelected) {
        query = require('@/graphql/mutations/UpdateJobResourceCheck.graphql');
        variables = this.resolveUpdateJobResourceCheckInput(resource);
      } else {
        query = require('@/graphql/mutations/UpdateJobResourceNegative.graphql');
        variables = this.resolveUpdateJobResourceNegativeInput(resource);
      }
    }

    if (variables && query) {
      try {
        await this.$apollo.mutate({
          mutation: query,
          variables: {input: variables},
        });
      } catch (error) {
        await this.$swal('Error', error.message, 'warning');
      }
    }

    resource.isMutating = false;
  }


  private resolveUpdateJobResourceNegativeInput(resource: Resource) {
    if (!this.jobInfo || !this.jobInfo.job) {
      return;
    }
    // Yes this is a keeper, so we update this in the database
    // set value to null
    return {
      job_id: this.jobInfo!.job!.id,
      resource_id: resource.id,
      option_id: this.selectedParameterOption.id,
    } as UpdateJobResourceNegativeInput;

    return false;
  }


  private resolveUpdateJobResourceCheckInput(resource: Resource) {
    if (!this.JobDataset || !this.JobDataset.job) {
      return;
    }
    if (!resource.isSelected) {
      if (this.isBooleanToggleMode) {
        // in a booleantask the options can be only 'true' or 'false'.
        // We are getting the opposite option from the currently selected option for the items that were not marked
        const theInverseOption = this.options.find((option: Option) => option.value
          !== this.selectedParameterOption.value);
        if (theInverseOption) {
          return {
            job_id: this.jobInfo!.job!.id,
            resource_id: resource.id,
            value: theInverseOption.value,
            option_id: theInverseOption.id,
          } as UpdateJobResourceCheckInput;
        }
      }
    }

    if (resource.isSelected) {
      {
        return {
          job_id: this.jobInfo!.job!.id,
          resource_id: resource.id,
          value: this.selectedParameterOption.value,
          option_id: this.selectedParameterOption.id,
        } as UpdateJobResourceCheckInput;
      }
    }

    return false;
  }

  private async deleteFromDataset(resource: Resource, conditionStates: [ConditionState]) {
    resource.isMutating = true;

    const conditionsToCreateNegativesFor: string[] = [];
    conditionStates.forEach((conditionState: ConditionState) => {
      if (conditionState.doCreateNegative) {
        conditionsToCreateNegativesFor.push(conditionState.id);
      }
    });


    try {
      const variables: DeleteJobResourceInput = {
        job_id: this.jobInfo!.job!.id,
        resource_id: resource.id.toString(),
        condition_ids: conditionsToCreateNegativesFor,
      } as DeleteJobResourceInput;
      await this.$apollo.mutate({
        mutation: require('@/graphql/mutations/DeleteJobResource.graphql'),
        variables: {input: variables},
      });
    } catch (error) {
      await this.$swal('Error', error.message, 'warning');
    }

    resource.isMutating = false;
    resource.isDeleted = true;
  }

}
